import { Drawer } from "@mantine/core";

import MyPreferences from "./components/MyPreferences";

interface NotificationPreferencesDrawerProps {
  opened: boolean;
  onClose: () => void;
}

export default function NotificationPreferencesDrawer({
  opened,
  onClose,
}: NotificationPreferencesDrawerProps) {
  return (
    <Drawer
      size="md"
      opened={opened}
      position="right"
      onClose={onClose}
      title="Notification Settings"
      closeButtonProps={{ "aria-label": "Close notification settings" }}
    >
      <MyPreferences onSaved={onClose} onCancel={onClose} />
    </Drawer>
  );
}
